import type { ResponseConsumer } from "@ceeferenderer/itg-renderer-sdk";
import type { ITGMetadata } from "@ceeferenderer/itg-renderer-sdk/model/itgMetadata.model";
import { handleRender } from "./handleRender";
import { handleExit } from "./handleExit";
import { handleError } from "./handleError";
import type { LoginResponse } from "@dotcom/oauthjs";

type CustomAttribute = {
  key: string;
  value: string;
};
type WorkLog = {
  customAttributes?: CustomAttribute[];
};

export type Response = ResponseConsumer & {
  metaData: ITGMetadata;
  workLog: WorkLog;
};
export const handleResponse = (
  { html, metaData, errors, isExit, workLog }: Response,
  loginResponse: LoginResponse
): void => {
  if (errors) {
    handleError();
  } else if (isExit) {
    handleExit(workLog?.customAttributes?.find(({ key }) => key === "exitOption")?.value);
  } else {
    handleRender(html, metaData, loginResponse);
  }
};
